<template>
  <div
    :class="[
      'BaseAccordion',
      { open },
    ]">
    <header
      class="_title"
      tabindex="0"
      @click="open = !open"
      @keyup.enter="open = !open">
      <div
        class="pr-2">
        <slot
          name="title">
          title here
        </slot>
      </div>
      <div
        class="_arrow">
      </div>
    </header>

    <div
      class="_content">
      <div
        class="px-2 pb-2">
        <slot
          name="content">
          content here
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseAccordion',

  data() {
    return {
      open: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

$arrow-size: 12px;

.BaseAccordion {
  position: relative;
  margin-top: 8px;
  border: $border;
  border-radius: $radius;
  background-color: $white;
}

.BaseAccordion ._title {
  display: flex;
  padding: 16px;
  padding-right: 32px;
  align-items: center;
  font-weight: bold;
  justify-content: space-between;
  outline: none;
  cursor: pointer;
}

.BaseAccordion ._arrow {
  flex: 0 1 $arrow-size;
  width: $arrow-size;
  min-width: $arrow-size;
  height: $arrow-size;
  color: $mute;
  border-right: 2px solid $border-color;
  border-bottom: 2px solid $border-color;
  transform: rotate(45deg) translateY(-4px);
  will-change: transform;
}

.BaseAccordion.open {
  ._title {
    font-weight: bold;
  }
  ._content {
    max-height: none;
  }
  ._arrow {
    transform: rotate(-135deg) translateY(4px);
  }
}

.BaseAccordion ._content {
  max-height: 0;
  color: $mute;
  overflow: hidden;
}
</style>
